<div class="chart-card">
  <div class="eliso-card-title">{{ title }}</div>
  @if (chartOptions(); as options) {
    <div echarts [options]="options" style="width: 100%; height: 400px;"></div>
  }
  <!-- <dx-chart [dataSource]="data">
    <dxi-series
      *ngFor="let s of series"
      type="line"
      [valueField]="s.valueField"
      [argumentField]="s.argumentField"
      [name]="s.name"
      [color]="s.color"
    ></dxi-series>
    @if (visualRange()) {
      <dxi-value-axis [visualRange]="visualRange()"></dxi-value-axis>
    }
    <dxo-legend [visible]="false"></dxo-legend>
    <dxo-export [enabled]="false"></dxo-export>
  </dx-chart> -->
</div>
